<ng-container *ngIf="notices && notices.length && hasVisibleNotices()">
  <div *ngIf="!isDismissed(notices[currentIndex]?.Id)"
       [ngClass]="{
         'banner-info': notices[currentIndex]?.Severity === 'INFO',
         'banner-warning': notices[currentIndex]?.Severity === 'WARNING',
         'banner-critical': notices[currentIndex]?.Severity === 'CRITICAL'
       }"
       class="notice-banner"
       role="alert">
    <span class="banner-severity-icon">
      <mat-icon *ngIf="notices[currentIndex]?.Severity === 'INFO'">info</mat-icon>
      <mat-icon *ngIf="notices[currentIndex]?.Severity === 'WARNING'">warning_amber</mat-icon>
      <mat-icon *ngIf="notices[currentIndex]?.Severity === 'CRITICAL'">error</mat-icon>
    </span>
    <div class="banner-content">
      <strong class="banner-title" title="{{ notices[currentIndex]?.Title }}">{{ notices[currentIndex]?.Title }}</strong>
      <span class="banner-desc"
            matTooltip="{{ notices[currentIndex]?.Description }}">
        {{ notices[currentIndex]?.Description }}
      </span>
    </div>
    <div class="banner-controls">
      <ng-container *ngIf="hasMultipleVisibleNotices()">
        <button class="banner-ctrl-btn" aria-label="Previous" (click)="movePrev()">
          <mat-icon>keyboard_arrow_left</mat-icon>
        </button>
        <span class="banner-index">{{ visiblePosition }}/{{ visibleTotal }}</span>
        <button class="banner-ctrl-btn" aria-label="Next" (click)="moveNext()">
          <mat-icon>keyboard_arrow_right</mat-icon>
        </button>
      </ng-container>
      <button *ngIf="dismissable"
              class="banner-ctrl-btn"
              aria-label="Dismiss"
              (click)="dismiss(notices[currentIndex]?.Id)">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
</ng-container>
